import styled from '@emotion/styled';

import { fadeInUp } from '@/styles/motion';

export const Wrap = styled.main`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 2.4rem;
	max-width: 48rem;
	width: 100%;
	margin: 0 auto;
	padding: 4rem 0 6rem;
	animation: ${fadeInUp} ${(props) => props.theme.motion.duration.slower} ${(props) => props.theme.motion.easing.decelerate}
		both;
	@media screen and (max-width: 600px) {
		padding: 2.4rem 2rem 4rem;
	}
`;

export const Card = styled.div<{ variant: 'success' | 'fail' | 'unknown' }>`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
	align-items: center;
	text-align: center;
	padding: 2.4rem 2rem;
	border-radius: ${(props) => props.theme.borderRadius.md};
	border: 1px solid ${(props) => props.theme.colors.borderDefault};
	background: ${(props) => props.theme.colors.surfacePage};
	box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
	${(p) =>
		p.variant === 'success'
			? `border-color: ${p.theme.colors.primary200}; background: ${p.theme.colors.primary50};`
			: p.variant === 'fail'
				? `border-color: #fecaca; background: #fef2f2;`
				: ''}
`;

export const Title = styled.h1`
	margin: 0;
	color: ${(props) => props.theme.colors.textPrimary};
	font-size: ${(props) => props.theme.fontSize.size2xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 1.3;
	letter-spacing: -0.03em;
`;

export const Message = styled.p`
	margin: 0;
	color: ${(props) => props.theme.colors.textSecondary};
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	line-height: 1.55;
	letter-spacing: -0.02em;
	white-space: pre-wrap;
`;

export const DetailList = styled.ul`
	list-style: none;
	margin: 0;
	padding: 0;
	width: 100%;
	max-width: 32rem;
	text-align: left;
	li {
		display: flex;
		justify-content: space-between;
		gap: 1rem;
		padding: 0.6rem 0;
		border-bottom: 1px solid ${(props) => props.theme.colors.borderSubtle};
		font-size: ${(props) => props.theme.fontSize.sizeSm};
		color: ${(props) => props.theme.colors.textSecondary};
	}
	li:last-child {
		border-bottom: none;
	}
	.label {
		color: ${(props) => props.theme.colors.textMuted};
		flex-shrink: 0;
	}
`;

export const ButtonRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 1rem;
	width: 100%;
`;

export const PrimaryButton = styled.button`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
	line-height: 1.2;
	letter-spacing: -0.02em;
	background-color: ${(props) => props.theme.colors.primary400};
	color: ${(props) => props.theme.colors.surfacePage};
	min-height: ${(props) => props.theme.heights.buttonMd};
	height: ${(props) => props.theme.heights.buttonMd};
	padding: 0 2rem;
	border: none;
	border-radius: ${(props) => props.theme.borderRadius.sm};
	cursor: pointer;
	transition:
		background-color ${(props) => props.theme.motion.duration.fast} ${(props) => props.theme.motion.easing.standard},
		box-shadow ${(props) => props.theme.motion.duration.fast} ${(props) => props.theme.motion.easing.standard},
		transform ${(props) => props.theme.motion.duration.fast} ${(props) => props.theme.motion.easing.standard};
	:hover {
		background-color: ${(props) => props.theme.colors.primaryHover};
		box-shadow: 0 2px 8px rgba(18, 83, 158, 0.22);
	}
	:active {
		background-color: ${(props) => props.theme.colors.primaryActive};
		transform: scale(0.99);
	}
`;

export const SecondaryButton = styled(PrimaryButton)`
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	background-color: ${(props) => props.theme.colors.surfaceMuted};
	color: ${(props) => props.theme.colors.textPrimary};
	border: 1px solid ${(props) => props.theme.colors.borderSubtle};
	box-shadow: none;
	:hover {
		background-color: ${(props) => props.theme.colors.borderSubtle};
		border-color: ${(props) => props.theme.colors.borderDefault};
		box-shadow: none;
	}
	:active {
		background-color: ${(props) => props.theme.colors.borderSubtle};
	}
`;
